import { FC } from 'react';

import useDismissActivationOnboardingCardOrder from 'common/hooks/useDismissActivationOnboardingCardOrder/useDismissActicationOnboardingCardOrder';
import Button from 'components/_core/Button';
import SunshineModal from 'components/_core/SunshineModal';
import Text from 'components/_core/Text';
import { ActionItem } from 'features/PostOnboardingAccountSetup/context';

import coneImg from '../../../../assets/brand/cone.png';
import locales from './locales';

interface OnboardingStepRemovalModalProps {
  isOpen: boolean;
  onClose: () => void;
  selectedActionItem: ActionItem;
}

const OnboardingStepRemovalModal: FC<OnboardingStepRemovalModalProps> = ({
  isOpen,
  onClose,
  selectedActionItem,
}) => {
  const [dismissCardOrder, { loading: dismissCardOrderLoading }] =
    useDismissActivationOnboardingCardOrder();

  const removeItem = async () => {
    // for now, can only dismiss card ordering option
    if (selectedActionItem.key === 'FIRST_CARD_ORDERED') {
      await dismissCardOrder();
    }
    onClose();
  };

  return (
    <SunshineModal isOpen={isOpen} onClose={onClose}>
      <SunshineModal.Header />

      <SunshineModal.Body>
        <SunshineModal.Body.Image src={coneImg} />
        <SunshineModal.Title>{locales.title}</SunshineModal.Title>
        <Text>{locales.description}</Text>
      </SunshineModal.Body>

      <SunshineModal.Footer>
        <Button
          icon="arrow-right"
          isLoading={dismissCardOrderLoading}
          onClick={removeItem}
        >
          {locales.submit}
        </Button>
      </SunshineModal.Footer>
    </SunshineModal>
  );
};

export default OnboardingStepRemovalModal;
